import { useTranslation } from 'react-i18next';

interface QRCodeProps {
  size?: number;
}

export default function QRCode({ size = 200 }: QRCodeProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center gap-20">
      {/* Spanish QR Code */}
      <div className="flex flex-col items-center gap-4">
        <div className="flex items-center gap-2 mb-2">
          <i className="ri-translate text-2xl text-orange-600"></i>
          <span className="text-xl font-bold text-orange-600">{t('contact_spanish')}</span>
        </div>
        <div className="bg-white p-4 rounded-2xl shadow-xl">
          <img
            src="https://api.qrserver.com/v1/create-qr-code/?size=450x450&data=https://wa.me/16786931234"
            alt="QR Code WhatsApp Español"
            style={{ width: `${size}px`, height: `${size}px` }}
            className="rounded-lg"
          />
        </div>
        <p className="text-lg text-orange-600 font-semibold">678 693 1234</p>
      </div>

      {/* English QR Code */}
      <div className="flex flex-col items-center gap-4">
        <div className="flex items-center gap-2 mb-2">
          <i className="ri-global-line text-2xl text-orange-600"></i>
          <span className="text-xl font-bold text-orange-600">{t('contact_english')}</span>
        </div>
        <div className="bg-white p-4 rounded-2xl shadow-xl">
          <img
            src="https://api.qrserver.com/v1/create-qr-code/?size=450x450&data=https://wa.me/14705408595"
            alt="QR Code WhatsApp English"
            style={{ width: `${size}px`, height: `${size}px` }}
            className="rounded-lg"
          />
        </div>
        <p className="text-lg text-orange-600 font-semibold">470 540 8595</p>
      </div>
    </div>
  );
}
